module.exports = {
      id: "fb-usage",
      viewBox: "0 0 20 20",
      url: "/" + "sprite-72169aba3aaebb7b19ede7951c92022d.svg#fb",
      toString: function () {
        return this.url;
      }
    }